export function blankStringToNull(str?: string | null) {
  if (!str) {
    return null;
  }

  if (str.length === 0) {
    return null;
  }

  return str;
}

export function normalizeForSearch(value: string): string {
  return value
    .normalize("NFD")
    .replaceAll(/\p{Diacritic}/gu, "")
    .trim()
    .toLocaleLowerCase();
}

export function matchesNameSearch(name: string, query: string): boolean {
  return normalizeForSearch(name).includes(normalizeForSearch(query));
}
